import { render } from "./AddCategoriePage.vue?vue&type=template&id=c985c1d2&ts=true"
import script from "./AddCategoriePage.vue?vue&type=script&lang=ts"
export * from "./AddCategoriePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__